/**
 * Provider del contexto de flota (F2). Suscribe el `subscribe` inyectado y
 * publica los markers al árbol. La lógica vive en `fleetContext.ts`.
 */
import { useEffect, useState, type ReactNode } from 'react';
import type { FleetMarker } from '../data/fleet';
import { FleetContext, type FleetSubscribe } from './fleetContext';

export function FleetProvider({
  subscribe,
  children,
}: {
  subscribe?: FleetSubscribe;
  children: ReactNode;
}): ReactNode {
  const [markers, setMarkers] = useState<FleetMarker[]>([]);

  useEffect(() => {
    if (!subscribe) return;
    return subscribe(setMarkers);
  }, [subscribe]);

  return <FleetContext.Provider value={markers}>{children}</FleetContext.Provider>;
}
